import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultInfo } from '../entities/ResultInfo';
import { BehaviorSubject, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Client } from '../entities/client';
import { ClientStorage } from '../entities/clientStorage';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { LoginService } from '../services/login.service';
import { getLocalePluralCase } from '@angular/common';
import { TokenService } from '../services/token.service';
import { nextTick } from 'process';

@Injectable({
  providedIn: 'root',
})
export class GenericService<T> {
  usertokens: string;
  token: string;
  user: string;
  client: Client;
  clientStorage: ClientStorage;
  authenticationState = new BehaviorSubject(false);
  loading: HTMLIonLoadingElement;
  isLoading: Boolean = false;

  constructor(
    private http: HttpClient,
    private storage: Storage,
    private helper: JwtHelperService,
    private router: Router,
    public loadingController: LoadingController,
    private loginServices: LoginService,
    private tokenService: TokenService
  ) {}

  MethodGetTokenAsync(url: string): Promise<ResultInfo<T>> {
    if (!this.isLoading) {
      this.presentLoading(url);
    }
    return new Promise<ResultInfo<T>>((resolve, reject) => {
      this.tokenService.ActualizarToken().then((respuesta) => {
        if (respuesta) {
          let resp: ClientStorage = respuesta;
          const httpOptions = {
            headers: new HttpHeaders().set(
              'Authorization',
              'Bearer ' + resp.Token
            ),
          };
          let response = this.http.get<ResultInfo<T>>(url, httpOptions);
          response.subscribe(
            (data) => {
              resolve(data);
              if (this.isLoading) {
                this.dismissLoading(url);
              }
              
            },
            (err) => {
              reject(err);
              if (this.isLoading) {
                this.dismissLoading(url);
              }
            }
          );
        }
      });
    });
  }

  MethodPostTokenAsync(model: any, url: string): Promise<ResultInfo<T>> {
    if (!this.isLoading) {
      this.presentLoading(url);
    }
    return new Promise<ResultInfo<T>>((resolve, reject) => {
      this.tokenService.ActualizarToken().then((respuesta) => {
        let resp: ClientStorage = respuesta;
        const httpOptions = {
          headers: new HttpHeaders().set(
            'Authorization',
            'Bearer ' + resp.Token
          ),
        };
        let response = this.http.post<ResultInfo<T>>(url, model, httpOptions);
        response.subscribe(
          (data) => {
            resolve(data);

            if (this.isLoading) {
              this.dismissLoading(url);
            }
          },
          (err) => {
            reject(err);
            if (this.isLoading) {
              this.dismissLoading(url);
            }
          }
        );
      });
    });
  }

  async presentLoading(url: string) {
    this.isLoading = true;

    return await this.loadingController
      .create({
        duration: 300000,
        spinner: 'bubbles'
      })
      .then((a) => {
        if (this.isLoading) {
          a.present().then(() => {
            if (!this.isLoading) {
              a.dismiss().then(() => {});
            }
          });
        }
      });
  }

  async dismissLoading(url: string) {
    this.isLoading = false;

    return await this.loadingController.dismiss().then(() => {});
  }
}
